import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2811_21820)" }, [
      _createElementVNode("path", {
        fill: "#fff",
        d: "M10 14.055c3.314 0 6.56-1.008 8.11-2.47l-.726-1.164c-1.473 1.28-4.429 2.17-7.384 2.17s-5.911-.89-7.384-2.17l-.727 1.163c1.55 1.463 4.797 2.471 8.11 2.471m0 6.153c5 0 8.333-1.89 8.333-4.564V3.92h-1.56v11.725c0 1.793-2.713 3.101-6.773 3.101s-6.773-1.308-6.773-3.1V3.918h-1.56v11.725C1.667 18.32 5 20.208 10 20.208m0-12.17c5 0 8.333-1.677 8.333-4.119S15-.208 10-.208 1.667 1.478 1.667 3.919C1.667 6.361 5 8.038 10 8.038m0-1.464c-4.06 0-6.773-1.094-6.773-2.655 0-1.627 2.713-2.761 6.773-2.761s6.773 1.134 6.773 2.761c0 1.56-2.713 2.655-6.773 2.655"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2811_21820" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }